var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CF0000",
    d: "M1.354.646l92 92M92.646.646l-92 92"
  })));
}

export default SvgCross;